module.exports = __webpack_public_path__ + "static/media/02.c5d9868b.svg";